<template>
  <div class="college-list">
    <div class="college-list-header">摄像头分布</div>
    <el-collapse class="collapse-box school-collapse-box" accordion>
      <el-collapse-item v-for="(item, index) in collegeList" :key="index">
        <template slot="title">
          <div class="collapse-title" @click="selectCollege(item, index)">
            <div class="title-school-info">
              <div class="title-school-name">{{ item.schoolName }}</div>
              <div class="title-school-icon-address">
                <img
                  src="@/assets/img/schoolMonitorCenter/school-location.png"
                  alt=""
                />
                <div class="title-school-address">
                  {{ item.schoolAddress }}
                </div>
              </div>
            </div>
            <div class="title-school-monitor">
              <img
                src="@/assets/img/schoolMonitorCenter/select-video-seat-icon.png"
                alt=""
              />
              <div class="monitor-info">
                <div>{{ item.numberMonitoring }}</div>
                <div>监控总数</div>
              </div>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div
            class="monitor-adddress"
            v-for="(monitor, key) in item.monitorNameConnection"
            :key="key"
            @click="selectMonitor(monitor, key)"
          >
            {{ monitor.monitorName }}
          </div>
        </div>
      </el-collapse-item>
      <div class="no-school" v-if="collegeList.lenght == 0">
        暂无数据
      </div>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "SafetyCenterCollege",
  components: {},
  props: {
    collegeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    selectCollege(item) {
      // console.log(item);
      this.$store.commit("updateUniversitySelectCollege", item);
    },
    selectMonitor(item) {
      // console.log(item)
      this.$store.commit("updateUniversitySelectVideo", item);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.college-list {
  margin: 20px 90px;
  width: 440px;
  height: 420px;
  padding: 20px 10px;
  background: url("~@/assets/img/bigDataCollge/chart-view-bg-two.png");
  background-size: 100% 100%;
  .college-list-header {
    padding-left: 20px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cbe0ff;
    position: relative;
    top: -8px;
  }
  .collapse-box {
    width: 100%;
    overflow: scroll;
    height: 360px;
    background-color: transparent;
    border: none;
  }
  .collapse-title {
    height: 80px;
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-school-info {
      height: 80px;
      padding-left: 20px;
      width: 60%;
      display: flex;
      justify-content: center;
      // align-items: center;
      flex-direction: column;
      line-height: 1;
      .title-school-name {
        width: 100%;
        font-size: 16px;
        color: #c4f0ff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .title-school-icon-address {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 5px;
        img {
          width: 12px;
          height: 12px;
          margin-right: 10px;
        }
        .title-school-address {
          width: 140px;
          // height: 12px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .title-school-monitor {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 1;
      img {
        width: 40px;
        height: 40px;
      }
      .monitor-info {
        margin-right: 10px;
        div {
          &:first-child {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4f0ff;
            line-height: 22px;
          }
          &:last-child {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(196, 240, 255, 0.8);
            line-height: 20px;
          }
        }
      }
    }
  }
  /deep/ .school-collapse-box {
    .el-collapse-item__wrap {
      background-color: transparent;
    }
    .el-collapse-item__header {
      height: 60px;
      background-color: transparent;
    }
    .el-icon-arrow-right:before {
      color: #c4f0ff;
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
    .el-collapse-item {
      &.is-disabled {
        .el-collapse-item__header {
          cursor: pointer;
        }
      }
    }
  }
  .collapse-content {
    padding-left: 20px;
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    .monitor-adddress {
      margin-bottom: 8px;
      margin-right: 8px;
      width: 124px;
      height: 31px;
      padding: 0 5px;
      box-shadow: 0px 0px 16px 0px #3f78bc inset;
      border-radius: 1px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4f0ff;
      line-height: 31px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      // &:nth-child(3n) {
      //   margin-right: 0;
      // }
    }
  }
  .no-school {
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
